export enum ConsentStatus {
  ACCEPTED = 'ACCEPTED',
  WITHDRAWN = 'WITHDRAWN',
  OUTDATED = 'OUTDATED',
  NOT_ACCEPTED = 'NOT_ACCEPTED',
}
